namespace TabAurous.Stock {
    export namespace OwnJewellerySummaryService {
        export const baseUrl = 'Stock/OwnJewellerySummary';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/OwnJewellerySummary/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OwnJewellerySummaryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
